<template>
    <div>
        <v-container class="container-600 overflow-hidden project_header py-0">
            <v-layout v-if="project_detail">
                <div id="properties_items" class="" style="width: 100%;">
                    <v-row class="">
                        <v-col cols="12" class="mt-0 pt-0">
                            <v-card
                                    class="mx-auto my-3"
                                    flat
                                    :id="'project_'+project_detail.project_id"
                            >
                                <div class="row ma-0" style="height: 150px;">
                                    <div class="col-6 pa-0 d-flex flex-column justify-space-between" style="background-color: #e6e6e6;">
                                        <div class="pa-3">
                                            <div>
                                                <div class="text-lpn" style="font-size: 0.85em;line-height: 1.2">{{project_detail.project_name_th}}</div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="grey--text text--accent-4" style="font-size: 0.65em;line-height: 1.2">{{ project_detail.project_caption }}</div>
                                            </div>
                                        </div>
                                        <div class="bg-lpn" :style="'border-left: 8px solid'+getProjectColor(project_detail.project_shortname)+';'">
<!--                                            <div class="d-flex align-center" style="height: 30px;">-->
<!--                                                <div class="white&#45;&#45;text text&#45;&#45;accent-4 pa-1 px-2" style="font-size: 0.5em;line-height: 1.2">{{ project_detail.project_shortname }}</div>-->
<!--                                            </div>-->
                                            <v-img
                                                    :src="require('@/assets/logo_project/'+project_detail.project_code+'.png')"
                                                    @error=""
                                                    :alt="project_detail.project_name_th"
                                                    contain
                                                    position="left"
                                                    height="30"
                                            ></v-img>
                                        </div>
                                    </div>
                                    <div class="col-6 pa-0" :style="'background-image: linear-gradient(to top,rgba(0, 0, 0, 0.0),rgba(0, 0, 0, 0)),url(\''+project_detail.pj_image_link+'\');background-repeat: no-repeat;background-size: 100% 100%, cover;background-position: center;'">
                                    </div>
                                </div>

                            </v-card>
                        </v-col>
                    </v-row>

                </div>
            </v-layout>
        </v-container>
    </div>

</template>

<script>
    export default {
        name: "ProjectHeader",
        props: {
            project_detail:{type: Object, default: []},
            route_data:{type: Object, default: []},
        }
    }
</script>

<style scoped>
    .project_header{
        border-top-right-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }
    .project_detail_title{
        top:10px;
        width: 100%;
        padding-left:0 !important;
        /*padding-bottom: 50px !important;*/
        white-space:unset;
        /*padding-left:5px !important;*/
    }
</style>
